export default () => {
    const mobileRegex = /Mobi|iP(hone|od|ad)|Android|BlackBerry/;
    const isNavigatorAvailable = typeof navigator !== 'undefined';
    if (isNavigatorAvailable) {
        return mobileRegex.test(navigator.userAgent);
    }
    return false;
};
